// extracted by mini-css-extract-plugin
module.exports = {"item":"Layout__item__2Yb68","itemRow":"Layout__itemRow__3byNF","itemTitle":"Layout__itemTitle__bAs_F","itemRight":"Layout__itemRight__3hTSq","text":"Layout__text__3nDBB"};